// Module
var code = `<div class="group-loans-create-members">
  <table class="table table--last-column-to-right">
    <thead>
      <th>No</th>
      <th>Customer name</th>
      <th>Total active loans</th>
      <th>Total outstanding balance</th>
      <th>New product name</th>
      <th>New outstanding balance</th>
      <th>New release amount</th>
      <th>Applying</th>
      <th>Actions</th>
    </thead>
    <tbody>
    <tr ng-repeat="member in \$ctrl.members" ng-class="{'member-configured': member.newLoan}">
      <td>{{\$index + 1}}.</td>
      <td>{{member.effectiveName}}</td>
      <td>
        {{\$ctrl.countActiveLoans(member)}}
      </td>
      <td>
        {{\$ctrl.calculateOutstandingBalance(member) | nxCurrency }}
      </td>
      <td>
        {{member.newProduct.productDefinition.productName}}
      </td>
      <td>
        {{\$ctrl.calculateNewOutstandingBalance(member) | nxCurrency}}
      </td>
      <td>
        {{member.newLoanCalculation.releaseAmount | nxCurrency}}
      </td>
      <td>
        <label class="label-checkbox" ng-if="!member.newLoan">
          <input type="checkbox"
                 ng-model="member.applying"
          />
        </label>
      </td>
      <td>
        <div class="summary-actions ng-scope">
          <button class="btn btn-danger"
                  ng-if="member.newLoan"
                  ng-click="\$ctrl.editLoan(member)">
            Edit
          </button>
          <button class="btn btn-danger"
                  ng-if="member.newLoan"
                  ng-click="\$ctrl.clearLoan(member)">
            Clear
          </button>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <div class="buttons">
    <button class="btn btn-warning"
            ng-click="\$ctrl.cancel()">
      Cancel
    </button>
    <button class="btn btn-info"
            ng-disabled="\$ctrl.noApplyingMembers()"
            ng-click="\$ctrl.prepareLoanAction()">
      Prepare loan
    </button>
    <button class="btn btn-info"
      ng-if="!\$ctrl.noProductsAdded()"
      ng-click="\$ctrl.editGroupLoanAction()">
      Edit application
    </button>
    <button class="btn btn-success"
            ng-disabled="\$ctrl.noProductsAdded()"
            ng-click="\$ctrl.saveApplication()"
    >
      Save application
    </button>
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/group-loans/group-loans-create/group-loans-create-members.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;